import React             from 'react';
import View              from '@widesk-ui/components/View';
import { RightOutlined } from '@ant-design/icons';
import { DownOutlined }  from '@ant-design/icons';
import useDesignTokens   from '@/hooks/useDesignTokens';

const CollapsiblePanel = ({ title, children }: {
	title: string;
	children: React.ReactNode;
}) => {
	const tokens = useDesignTokens();
	const [expanded, setExpanded] = React.useState(false);

	return (
		<View
			br={8}
			style={{ border: `1px solid ${tokens.border.default}`, background: tokens.surface.elevated, overflow: 'hidden' }}
		>
			<View
				row
				gap="xs"
				centerV
				bold
				size={13}
				p="sm"
				color={tokens.text.default}
				pointer
				onClick={() => setExpanded(v => !v)}
			>
				{expanded ? <DownOutlined /> : <RightOutlined />}
				{title}
			</View>

			{expanded && (
				<View px="sm" pb="sm" gap="sm">
					{children}
				</View>
			)}
		</View>
	);
};

export default CollapsiblePanel;
